/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Reactivate_ConfirmInputs */



/**
* | output |
* | --- |
* | "Reactivate" |
*
* @param {Members_Reactivate_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_reactivate_confirm = /** @type {((inputs?: Members_Reactivate_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Reactivate_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Reaktivieren")
	return /** @type {LocalizedString} */ ("Reactivate")
});